import ArticlePage, {
  IArticlePageProps,
} from '@bridebook/web/app-basic/components/articles/article-page/article-page';
import { fetchArticlePageData } from '@bridebook/web/app-basic/lib/article/fetch-article-page-data';
import {
  EdgeCacheTTL,
  basicGSSPWrapper,
} from '@bridebook/web/app-basic/lib/get-basic-server-side-props-wrapper';
import { AppType } from '@bridebook/web/pages/_app';

const Article = (props: IArticlePageProps) => <ArticlePage {...props} />;

export const getServerSideProps = basicGSSPWrapper(
  ['articles'],
  async ({ store, context, initialAppState }) => {
    const article = await fetchArticlePageData({ store, context, initialAppState });

    if (!article) {
      return { notFound: true };
    }

    return { props: {} };
  },
  {
    vercelCacheControl: {
      maxAge: EdgeCacheTTL.WEEK,
      sMaxAge: EdgeCacheTTL.WEEK,
      staleWhileRevalidate: EdgeCacheTTL.MONTH,
    },
    cloudflareCacheControl: {
      maxAge: EdgeCacheTTL.DAY,
      sMaxAge: EdgeCacheTTL.DAY,
      staleWhileRevalidate: EdgeCacheTTL.WEEK,
    },
  },
);

Article.AppType = AppType.Basic;

export default Article;
